<template>
    <div class="table">
        <div class="container" style="position: relative;">
            <div class="circle-parent">
                    <div :style="{borderColor:getColor(`${type.toUpperCase()} Initiation`)}"  class="circle">
                        <el-tooltip class="item" effect="dark" :content="getTitle(`${type.toUpperCase()} Initiation`)" placement="top-end">
                            <p>Publish</p>
                        </el-tooltip>
                    </div>
                    <div :style="{borderColor:getColor('Supplier Submit Proposal')}" class="circle">
                        <el-tooltip class="item" effect="dark" :content="getTitle('Supplier Submit Proposal')" placement="top-end">
                            <div>
                                <p>Proposal</p><p>（{{romanRoundNumber}}）</p>
                            </div>
                        </el-tooltip>
                    </div>
                    <div :style="{borderColor:getColor('Recommendation')}" class="circle">
                        <el-tooltip class="item" effect="dark" :content="getTitle('Recommendation')" placement="top-end">
                            <div>
                                <p>Recommen</p><p>dation</p>
                            </div>
                        </el-tooltip>
                    </div>
                    <div :style="{borderColor:getColor('Business Case')}" v-if="type=='ssr'" class="circle">
                        <el-tooltip class="item" effect="dark" :content="getTitle('Business Case')" placement="top-end">
                            <p>BC</p>
                        </el-tooltip>
                    </div>
            </div>
          <div class="legend">
            <ul>
              <li style="color: #909399"><i class="icon icon-yuan"></i>{{$t("ssrManage.greMsg")}}</li>
              <li style="color: #67C23A"><i class="icon icon-yuan"></i>{{$t("ssrManage.greenMsg")}}</li>
              <li style="color: #E6A23C"><i class="icon icon-yuan"></i>{{$t("ssrManage.yellowMsg")}}</li>
              <li style="color: #FB4E4E"><i class="icon icon-yuan"></i>{{$t("ssrManage.redMsg")}}</li>
            </ul>
          </div>
            <el-tabs type="border-card">
                <el-tab-pane :label="`${type.toUpperCase()} Information`">
                    <div style="padding-bottom: 15px;">
<!--                        <el-button v-if="ssr.canEdit" type="primary" @click="showIssueDialog = true">{{$t('common.edit')}}</el-button>-->
<!--                        <el-button v-if="ssr.owned && ['DRAFT','STATUS_SUBMIT','FINISH'].includes(ssr.status)" type="primary" @click="">{{$t('ssrManage.roundsIssue')}}</el-button>-->
                        <el-button v-if="ssr.owned && ssr.status != 'SUSPEND'" type="primary" @click="showDialog = true">{{$t('ssrManage.breakUp')}}</el-button>
                        <el-button v-if="canFinishRound" type="primary" @click="roundsEnd">{{$t('ssrManage.roundsEnd')}}</el-button>
                    </div>
                    <ssr-manage-add v-model="ssr"/>
                </el-tab-pane>
                <el-tab-pane label="Proposal">
                    <supplier-pane :rounds="ssr.ssrRounds" :ssr="ssr"/>
                </el-tab-pane>
                <el-tab-pane label="PQCP">
                    <offer-info-pane :rounds="ssr.ssrRounds"/>
                </el-tab-pane>
                <el-tab-pane label="Cost Breakdown">
                    <cose-info-pane :rounds="ssr.ssrRounds"/>
                </el-tab-pane>
                <el-tab-pane label="Capacity Analysis">
                    <production-info-pane :rounds="ssr.ssrRounds"/>
                </el-tab-pane>
                <el-tab-pane label="Logistics Capacity">
                    <logistics-pane :rounds="ssr.ssrRounds"/>
                </el-tab-pane>
                <el-tab-pane label="SPM">
                    <spm-core-pane :rounds="ssr.ssrRounds" :ssr="ssr"/>
                </el-tab-pane>
                <el-tab-pane label="Log">
                    <workflow-log-table :logs="ssr.workflowLogs"></workflow-log-table>
                </el-tab-pane>
            </el-tabs>

            <!--=========终止=========-->
            <el-dialog title="是否需要终止流程？" :visible.sync="showDialog" width="500px">
                <el-form label-width="100px">
                    <el-row type="flex" justify="space-around">
                        <el-col :span="20">
                            <el-form-item label="填写备注" placeholder="" prop="remark">
                                <el-input v-model="remark" type="textarea" class="handle-input"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button type="primary" @click="breakUp">Submit</el-button>
                    <el-button type="primary" @click="showDialog = false">{{'Close'}}</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import ssrManageAdd from "@/components/page/ssr-manage/ssr-manage-add";
    import supplierPane from "@/components/page/ssr-manage/supplier-pane";
    import offerInfoPane from "@/components/page/ssr-manage/offer-info-pane";
    import coseInfoPane from "@/components/page/ssr-manage/cost-info-pane";
    import productionInfoPane from "@/components/page/ssr-manage/production-info-pane";
    import logisticsPane from "@/components/page/ssr-manage/logistics-pane";
    import spmCorePane from "@/components/page/ssr-manage/spm-core-pane";
    import commonFun from "@/utils/commonFun";
    import WorkflowLogTable from "@/components/common/workflowLogTable";
    import Moment from "moment";

    export default {
        name: 'ssr-detail-ss',
        extends: commonMethods,
        components: {
            WorkflowLogTable,
            ssrManageAdd,
            supplierPane,
            offerInfoPane,
            coseInfoPane,
            productionInfoPane,
            logisticsPane,
            spmCorePane
        },
        computed: {
            type() {
                return this.$route.meta.type;
            },
            romanRoundNumber() {
                return commonFun.toRomanNum(this.ssr.currentRound);
            },
            canFinishRound() {
                return this.ssr.owned && 'ISSUED'== this.ssr.status;
            },
            getTitle(item) {
                let that = this;
                return function (item) {
                    if (commonFun.isEmpty(that.ssr.events) || commonFun.isEmpty(that.ssr.ssrRounds)) {
                        return that.$t("ssrManage.greMsg");
                    }
                    let filterElement = that.ssr.events.filter(event => event.projectItem == item)[0];
                    let currentRound = that.ssr.ssrRounds.filter(round => round.roundNumber==that.ssr.currentRound)[0];
                    if (currentRound == null) {
                        return that.$t("ssrManage.greMsg");
                    }
                    let issueDate = currentRound.issueDate;
                    let quoteDate = currentRound.quoteDate;
                    let recommendationDate = currentRound.recommendationDate;
                    let bcCreateDate = currentRound.bcCreateDate;
                  if (null != filterElement && null != filterElement.deadline) {
                        let date = null;
                        switch (item) {
                            case 'SSR/RFP Initiation':
                                if (issueDate != null) {
                                    date = issueDate;
                                } else {
                                    return that.$t("ssrManage.greMsg");
                                }
                                break;
                            case 'Supplier Submit Proposal':
                                if (issueDate != null) {
                                    if (quoteDate != null) {
                                        date = quoteDate;
                                    } else {
                                        return that.$t("ssrManage.greMsg");
                                    }
                                } else {
                                    return that.$t("ssrManage.greMsg");
                                }
                                break;
                            case 'Recommendation':
                                if (quoteDate != null) {
                                    if (recommendationDate != null) {
                                        date = recommendationDate;
                                    } else {
                                        return that.$t("ssrManage.greMsg");
                                    }
                                } else {
                                    return that.$t("ssrManage.greMsg");
                                }
                                break;
                            case 'Business Case':
                                if (recommendationDate != null) {
                                    if (bcCreateDate != null) {
                                        date = bcCreateDate;
                                    } else {
                                        return that.$t("ssrManage.greMsg");
                                    }
                                } else {
                                    return that.$t("ssrManage.greMsg");
                                }
                                break;
                        }
                        if (date == null) {
                            return that.$t("ssrManage.greMsg");
                        }
                        let deadline = new Date(filterElement.deadline);
                        let overDays = Moment(date).diff(Moment(deadline), 'days');
                        if (overDays > 14) {
                            return that.$t("ssrManage.redMsg");
                        } else if (overDays > 0) {
                            return that.$t("ssrManage.yellowMsg");
                        } else if (overDays <= 0) {
                            return that.$t("ssrManage.greenMsg");
                        }
                    }
                }
            },
            getColor(item) {
                let yellow = "#E6A23C";
                let green = "#67C23A";
                let gre = "#909399";
                let red = "#FB4E4E";
                let that = this;
                return function (item) {
                    if (commonFun.isEmpty(that.ssr.events) || commonFun.isEmpty(that.ssr.ssrRounds)) {
                        return gre;
                    }
                    let filterElement = that.ssr.events.filter(event => event.projectItem == item)[0];
                    let currentRound = that.ssr.ssrRounds.filter(round => round.roundNumber==that.ssr.currentRound)[0];
                    if (currentRound == null) {
                        return gre;
                    }
                    let issueDate = currentRound.issueDate;
                    let quoteDate = currentRound.quoteDate;
                    let recommendationDate = currentRound.recommendationDate;
                    let bcCreateDate = currentRound.bcCreateDate;
                    if (null != filterElement && null != filterElement.deadline) {
                        let date = null;
                        switch (item) {
                            case 'SSR/RFP Initiation':
                            case 'SSR Initiation':
                            case 'RFP Initiation':
                                if (issueDate != null) {
                                    date = issueDate;
                                } else {
                                    return gre;
                                }
                                break;
                            case 'Supplier Submit Proposal':
                                if (issueDate != null) {
                                    if (quoteDate != null) {
                                        date = quoteDate;
                                    } else {
                                        return gre;
                                    }
                                } else {
                                    return gre;
                                }
                                break;
                            case 'Recommendation':
                                if (quoteDate != null) {
                                    if (recommendationDate != null) {
                                        date = recommendationDate;
                                    } else {
                                        return gre;
                                    }
                                } else {
                                    return gre;
                                }
                                break;
                            case 'Business Case':
                                if (recommendationDate != null) {
                                    if (bcCreateDate != null) {
                                        date = bcCreateDate;
                                    } else {
                                        return gre;
                                    }
                                } else {
                                    return gre;
                                }
                                break;
                        }
                        if (date == null) {
                            return gre;
                        }
                        let deadline = new Date(filterElement.deadline);
                        let overDays = Moment(date).diff(Moment(deadline), 'days');
                        if (overDays > 14) {
                            return red;
                        } else if (overDays > 0) {
                            return yellow;
                        } else if (overDays <= 0) {
                            return green;
                        }
                    }
                }
            }
        },
        data() {
            return {
                ssr: {
                    supplierCode: '',
                    supplierName: '',
                    address: '',
                    ssrRounds: []
                },
                labelPosition: 'right',
                remark: null,
                showDialog: false,
            }
        },
        created() {
        },
        methods: {
            //终止
            breakUp() {
                let that = this;
                if (commonFun.isEmpty(that.remark)) {
                    Message.error(that.$t("ssrManage.needSuspendRemark"));
                    return;
                }
                apiService.suspend({
                    ssrId:that.ssr.ttSsrId,
                    suspendReason:that.remark
                }).then(res=>{
                    if (res.code = 200) {
                        Message.success('Operate Success');
                        that.$store.dispatch("reload");
                        that.showDialog = false;
                    }
                });
            },
            //结束轮次
            async roundsEnd() {
                let that = this;
                if (await this.callConfirm({msg: '是否结束该轮次？'})) {
                    apiService.finishRound(this.ssr.ttSsrId).then(res=>{
                        if (res.code == 200) {
                            that.$store.dispatch("reload");
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped lang="scss">

    .legend{
      margin-left: 120px;
      text-align: left;
      position: absolute;
      right: 2em;
      top:1em;

      ul li {list-style: none;}
    }

    .circle-parent {
        text-align: center;
        margin: 0 auto;
        border-collapse: separate;
        border-spacing: 15px;
        display: table;
        position: relative;

        .circle {
            width: 80px;
            height: 80px;
            background-color: #F2F2F2;
            border-radius: 50%;
            -moz-border-radius: 50%;
            -webkit-border-radius: 50%;
            display: table-cell;
            vertical-align: middle;
            font-size: 14px;
            color: #195ad1;
            box-shadow: #666 0px 0px 5px;
            border-width: 5px;
            border-style: solid;
        }
    }
    .container{
        padding-top: 0px;
    }
</style>
